import { string } from "prop-types";
import { forwardRef, useMemo } from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components";

import FnrTypography from "FnrTypography";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrTappyShrink from "UI/FnrTappyShrink";

import externalNavigate from "Utilities/externalNavigate";

import { ButtonWrapper } from "../../shared";

const useHelpArticals = () => {
  const location = useLocation();

  return useMemo(() => {
    if (new RegExp(/\/user\/updateField\/\d+/).test(location.pathname))
      return [
        {
          label: "What is Intelligent Info Gathering?",
          url: "https://help.flocknote.com/article/433-member-resource-iig",
        },
      ];

    if (new RegExp(/\/note\/\d+/).test(location.pathname))
      return [
        {
          label: "What is the Note page?",
          url: "https://help.flocknote.com/article/434-member-resource-what-is-a-note-page",
        },
      ];

    if (new RegExp(/\/(user|completeProfile)/).test(location.pathname))
      return [
        {
          label: "What is a member profile?",
          url: "https://help.flocknote.com/article/435-member-resource-flocknote-profile",
        },
      ];

    if (new RegExp(/network\/\d+\/moregroups/).test(location.pathname))
      return [
        {
          label: "What does joining a group do?",
          url: "https://help.flocknote.com/article/436-member-resource-joining-groups",
        },
      ];

    if (new RegExp(/network\/\d+\/confirm/).test(location.pathname))
      return [
        {
          label: "I signed up for Flocknote. Now what?",
          url: "https://help.flocknote.com/article/437-member-resource-i-signed-up-for-flocknote-now-what",
        },
      ];

    if (new RegExp(/\/me\/(create|reset)Password/).test(location.pathname))
      return [
        {
          label: "How do I change my password?",
          url: "https://help.flocknote.com/article/59-how-do-i-change-my-password",
        },
      ];

    return [];
  }, [location.pathname]);
};

const HelpArticleButtonDisplay = ({ color, label }) => (
  <Wrapper>
    <SFnrContainedIcon color={color} icon="fa-external-link far" size="sm" />
    <FnrTypography italic color={color} type="copy" fontSize="sm">
      {label}
    </FnrTypography>
  </Wrapper>
);

const Wrapper = styled(FnrTappyShrink)`
  display: flex;
  max-width: fit-content;
  gap: 12px;
  padding-right: 12px;
`;

HelpArticleButtonDisplay.propTypes = { color: string, label: string };

const HelpArticlesList = () => {
  const helpArticles = useHelpArticals();
  return helpArticles.map(({ label, url }) => (
    <ButtonWrapper
      key={url}
      DisplayComponent={HelpArticleButtonDisplay}
      displayComponentProps={{ label }}
      onClick={() => externalNavigate(url)}
    />
  ));
};

const SFnrContainedIcon = styled(FnrContainedIcon)`
  width: 40px;
`;

const HelpArticles = () => {
  const helpArticles = useHelpArticals();
  if (helpArticles.length === 0) return null;
  return (
    <HelpArticlesContainer>
      <HelpArticlesList />
    </HelpArticlesContainer>
  );
};

const HelpArticlesContainer = styled.div`
  gap: 16px;
  padding: 4px 0 16px 0;
`;

export default HelpArticles;
